import { createSelector } from '@reduxjs/toolkit';
import selfSelector from '../self';

const tableSelector = createSelector(selfSelector, (analytic) => analytic.table);

export default tableSelector;
